import React from 'react'

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  fill?: string
}

const SvgIcon: React.FC<SvgIconProps> = ({ fill = 'currentColor', ...props }) => {
  return (
    <svg {...props} fill={fill} xmlns="http://www.w3.org/2000/svg">
      <g id="trophy-cup-silhouette" transform="translate(0 -2.897)">
        <path
          id="Path_1306"
          data-name="Path 1306"
          d="M12.024,3.651c.01-.46-.008-.75-.008-.75l-4.493,0H7.477l-4.494,0s-.017.291-.007.75H0v.491a6.212,6.212,0,0,0,1.65,4.2,3.686,3.686,0,0,0,2.53.908c.151,0,.307-.01.465-.024a4.342,4.342,0,0,0,1.964,1.6v2.156H4.44v1.35H3.723v.757h7.553V14.33H10.56V12.98H8.391V10.824a4.345,4.345,0,0,0,1.964-1.6c.159.014.314.023.466.023a3.686,3.686,0,0,0,2.529-.908A6.212,6.212,0,0,0,15,4.141v-.49ZM2.3,7.612a4.8,4.8,0,0,1-1.289-2.98H3.033a9.815,9.815,0,0,0,.749,3.1c.085.186.174.363.265.535A2.706,2.706,0,0,1,2.3,7.612Zm10.391,0a2.7,2.7,0,0,1-1.742.652c.091-.172.18-.349.265-.535a9.8,9.8,0,0,0,.749-3.1h2.017A4.794,4.794,0,0,1,12.7,7.612Z"
        />
      </g>
    </svg>
  )
}

type TrophyCupIconFilledProps = SvgIconProps

export const TrophyCupIconFilled: React.FC<TrophyCupIconFilledProps> = (props) => {
  return <SvgIcon {...props} viewBox="0 0 15 12.189" focusable="false" aria-hidden="true" />
}
